import { Icon } from '@chakra-ui/react'

type Props = {
    fill?: string
}

export const IconBeingProccesed = ({ fill }: Props): JSX.Element => {
    return (
        <Icon viewBox={`0 0 12 16`} w={`12px`} h={`16px`} fill="none">
            <path
                d="M11.5 0C11.775 0 12 0.223875 12 0.5C12 0.77625 11.775 1 11.5 1H11V2.39594C11 3.38437 10.675 4.34375 10.075 5.12813L7.87813 8L10.075 10.8719C10.675 11.6281 11 12.6156 11 13.6031V15H11.5C11.775 15 12 15.225 12 15.5C12 15.775 11.775 16 11.5 16H0.5C0.223875 16 0 15.775 0 15.5C0 15.225 0.223875 15 0.5 15H1V13.6031C1 12.6156 1.32531 11.6281 1.92531 10.8719L4.12187 8L1.92531 5.12813C1.32531 4.34375 1 3.38437 1 2.39594V1H0.5C0.223875 1 0 0.77625 0 0.5C0 0.223875 0.223875 0 0.5 0H11.5ZM10 1H2V2.39594C2 3.16562 2.25281 3.9125 2.71969 4.52187L5.14687 7.69688C5.28437 7.875 5.28437 8.09688 5.14687 8.30313L2.71969 11.4781C2.25281 12.0875 2 12.8344 2 13.6031V15H10V13.6031C10 12.8344 9.74687 12.0875 9.25313 11.4781L6.85313 8.30313C6.71563 8.09688 6.71563 7.875 6.85313 7.69688L9.25313 4.52187C9.74687 3.9125 10 3.16562 10 2.39594V1Z"
                fill={fill ? fill : '#F16422'}
            />
        </Icon>
    )
}
